import type { I18nActiveNamespaces } from '@/lib/i18n';

export type RecordConfig = {
  i18nNamespaces: I18nActiveNamespaces<
    'common' | 'record' | 'system' | 'payment' | 'checkout' | 'booking'
  >;
};

export const recordConfig: RecordConfig = {
  i18nNamespaces: [
    'common',
    'record',
    'system',
    'payment',
    'checkout',
    'booking',
  ],
};
